import React from 'react';
import cn from 'classnames';

import { useTranslation } from '@lt/localization';
import Keys from '@lt/components/icons-react/rebrand/Keys';
import PackageInfoItem from '../components/PackageInfoItem';
import AboutRoomButton from '../../AboutRoom';
import GoToHotelContainer from '../../GoToHotel/GoToHotelContainer';

import type { PropsFromRedux } from '.';
import styles from './packageRoomInfo.module.css';

const PackageRoomInfo = ({
  roomDescription,
  roomType,
  isMobile,
}: PropsFromRedux) => {
  const { t } = useTranslation();

  return (
    <PackageInfoItem icon={<Keys height={16} />}>
      <>
        <p className={styles.text}>{roomDescription}</p>
        {roomType && (
          <>
            <p className={styles.text}>·</p>
            <p className={styles.text}>{roomType}</p>
          </>
        )}
        <AboutRoomButton className={cn(styles.text, styles.link)} />
        <p className={styles.text}>·</p>
        <GoToHotelContainer
          className={cn(styles.text, styles.link)}
          functional
          primary={false}
          isMobile={isMobile}
        >
          {t('checkout.packageInfo.room.otherVariants')}
        </GoToHotelContainer>
      </>
    </PackageInfoItem>
  );
};

export default PackageRoomInfo;
